export function composeKey(ids) {
    return ids.join("_");
}
//# sourceMappingURL=composeKey.js.map